import { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from "axios";

import { HttpStatusCodes } from "src/constants";
import { RequestInputType } from "src/services";
import { debugInfo } from "src/utils/debugLog";

class AxiosHelper {
  readonly validateStatus = (status: number) => {
    return (
      status >= HttpStatusCodes.SUCCESS &&
      status < HttpStatusCodes.MULTIPLE_CHOICES
    );
  };

  readonly handleError = (error: AxiosError) => {
    if (error.response) {
      const data = error?.response?.data as ErrorResponse;
      if (Array.isArray(data.cause.errors)) {
        return {
          statusCode: Number(data.responseCode),
          cause: data.cause?.errors?.map((error) => error.message).join(", "),
          requestId: data.requestId,
        };
      }
    }
    if (error.request) {
      return {
        statusCode: error.status,
        cause: "Não foi possível realizar a requisição",
      };
    }

    return {
      statusCode: Number(error.code) || 500,
      cause: error.message,
    };
  };

  readonly interceptorRequest = (
    request: InternalAxiosRequestConfig<RequestInputType>,
  ) => {
    const { baseURL, data, method, url } = request;
    debugInfo(`-> [${method}] - ${baseURL}${url}`);

    debugInfo(`headers: ${JSON.stringify(request.headers, null, 2)}`);
    if (data) {
      debugInfo({ "BODY:": data });
    }

    return request;
  };

  readonly interceptorResponse = (response: AxiosResponse<CheckoutType>) => {
    const {
      status,
      config: { baseURL, url, method },
    } = response;

    const data = response.data;

    debugInfo(`<- [${method}] - ${baseURL}${url} - [${status}}]`);
    if (data) {
      debugInfo({ "BODY:": data });
    }

    return response;
  };
}

const ApiHelper = new AxiosHelper();
export default ApiHelper;
